import { Mail, MapPin, Linkedin, Instagram, Youtube, Facebook } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/config";

const FOOTER_SERVICES = [
    "Data & Analytics",
    "Website Design",
    "Logo & Branding",
    "AI Video & Ads",
    "Social Media Creatives",
    "Digital Marketing",
];

const SOCIALS = [
    { icon: Linkedin, href: CONTACT.linkedin, label: "LinkedIn", id: "footer-linkedin" },
    { icon: Instagram, href: CONTACT.instagram, label: "Instagram", id: "footer-instagram" },
    { icon: Youtube, href: CONTACT.youtube, label: "YouTube", id: "footer-youtube" },
    { icon: Facebook, href: CONTACT.facebook, label: "Facebook", id: "footer-facebook" },
];

export default function Footer() {
    return (
        <footer className="bg-burgundy text-cream pt-16 lg:pt-20 pb-8" data-testid="site-footer">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid gap-12 lg:grid-cols-12">
                    {/* Brand */}
                    <div className="lg:col-span-4">
                        <span className="inline-block bg-[#F5ECDD] rounded-xl p-3">
                            <img src="/analytrova-logo.jpg" alt="Analytrova" className="h-12 w-auto" />
                        </span>
                        <p className="mt-5 font-serif italic text-lg text-gold">Smart Data &amp; Creative Solutions</p>
                        <p className="mt-2 text-sm text-cream/60 max-w-xs">Where Data Meets Creativity.</p>
                        <div className="mt-6 flex gap-3">
                            {SOCIALS.map(({ icon: Icon, href, label, id }) => (
                                <a
                                    key={label}
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={label}
                                    className="w-10 h-10 rounded-full border border-cream/25 text-cream flex items-center justify-center transition-colors hover:bg-cream hover:text-burgundy"
                                    data-testid={id}
                                >
                                    <Icon className="w-4 h-4" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="lg:col-span-2">
                        <h4 className="text-[11px] font-semibold tracking-[0.26em] text-gold">QUICK LINKS</h4>
                        <ul className="mt-5 space-y-2.5">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <a href={l.href} className="text-[15px] text-cream/75 hover:text-cream transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(" ", "-")}`}>
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Our Services */}
                    <div className="lg:col-span-3">
                        <h4 className="text-[11px] font-semibold tracking-[0.26em] text-gold">OUR SERVICES</h4>
                        <ul className="mt-5 space-y-2.5">
                            {FOOTER_SERVICES.map((s) => (
                                <li key={s}>
                                    <a href="#services" className="text-[15px] text-cream/75 hover:text-cream transition-colors" data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                                        {s}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Get in touch */}
                    <div className="lg:col-span-3">
                        <h4 className="text-[11px] font-semibold tracking-[0.26em] text-gold">GET IN TOUCH</h4>
                        <ul className="mt-5 space-y-3.5">
                            <li className="flex items-center gap-3">
                                <Mail className="w-4 h-4 text-gold shrink-0" />
                                <a href={`mailto:${CONTACT.email}`} className="text-[15px] text-cream/75 hover:text-cream transition-colors break-all" data-testid="footer-email">
                                    {CONTACT.email}
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <MapPin className="w-4 h-4 text-gold shrink-0" />
                                <span className="text-[15px] text-cream/75">{CONTACT.location}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 border-t border-cream/15 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-[13px] text-cream/55">
                    <span>© 2026 Analytrova. All rights reserved.</span>
                    <span>Build Smarter | Grow Faster</span>
                </div>
            </div>
        </footer>
    );
}
